export var AccessibilityModule = /*#__PURE__*/function (AccessibilityModule) {
  AccessibilityModule["Zoom"] = "Zoom";
  AccessibilityModule["DarkMode"] = "DarkMode";
  AccessibilityModule["SimpleFont"] = "SimpleFont";
  AccessibilityModule["HighContrast"] = "HighContrast";
  AccessibilityModule["MarkInteractibleElements"] = "MarkInteractibleElements";
  AccessibilityModule["EmphasizeFocusedElement"] = "EmphasizeFocusedElement";
  AccessibilityModule["BlueFilter"] = "BlueFilter";
  AccessibilityModule["ColorBlindnessFilter"] = "ColorBlindnessFilter";
  AccessibilityModule["ContrastAndSaturation"] = "ContrastAndSaturation";
  AccessibilityModule["LowDistractionMode"] = "LowDistractionMode";
  AccessibilityModule["CursorSize"] = "CursorSize";
  return AccessibilityModule;
}(AccessibilityModule || {});
export const accessibilityModuleConfigsDefaults = {
  [AccessibilityModule.Zoom]: {
    value: 1
  },
  [AccessibilityModule.DarkMode]: {
    mode: 'inherit-browser'
  },
  [AccessibilityModule.SimpleFont]: {
    enabled: false
  },
  [AccessibilityModule.HighContrast]: {
    enabled: false
  },
  [AccessibilityModule.MarkInteractibleElements]: {
    enabled: false
  },
  [AccessibilityModule.EmphasizeFocusedElement]: {
    enabled: false
  },
  [AccessibilityModule.BlueFilter]: {
    intensity: 0
  },
  [AccessibilityModule.ColorBlindnessFilter]: {
    intensity: 0,
    type: 'red'
  },
  [AccessibilityModule.ContrastAndSaturation]: {
    contrast: 1,
    saturation: 1
  },
  [AccessibilityModule.LowDistractionMode]: {
    enabled: false
  },
  [AccessibilityModule.CursorSize]: {
    value: 1
  }
};
export const modulesEnabledByDefault = [AccessibilityModule.DarkMode];